import React, {Component} from 'react';
import {Redirect} from "react-router-dom";
import {connect} from 'react-redux'
import RaisedButton from 'material-ui/RaisedButton';
import {retrievePackages} from "store/packages/actions";
import {retrieveDifficulties} from "store/difficulties/actions";
import { translate } from 'react-i18next';


import PackageAddDialog from './PackageAddDialog';
import PackagesList from './PackagesList';

class PackagesPage extends Component {

    componentDidMount() {
        this.props.onMount();
    }


    render() {
        if (this.state && this.state.redirect) {
            return (<Redirect push to={this.state.redirect}/>);
        }

        const packages = this.props.package.items.filter(x => x.permission === 4);

        if (!packages.length) {
            return (
                <div>
                    <p style={{display: 'flex',  justifyContent:'center', marginTop: '30vh'}}>{this.props.t('package_management_you_have_no_own_package')}</p>
                    <div style={{display: 'flex',  justifyContent:'center'}}>
                        <PackageAddDialog wrapper={RaisedButton} wrapperProps={{label: this.props.t('create_package'), primary: true, labelStyle: {color: 'black'}}}/>
                    </div>
                </div>
            );
        }

        return (
            <PackagesList languages={this.props.lang.languages} packages={packages}/>
        );
    }

}

const mapStateToProps = (state) => {
    return {package: state.package, lang: state.lang}
};

const mapDispatchToProps = (dispatch) => {
    return {
        onMount: () => {
            dispatch(retrieveDifficulties());
            return dispatch(retrievePackages());
        }
    }
};


export default translate()(connect(mapStateToProps, mapDispatchToProps)(PackagesPage));



// WEBPACK FOOTER //
// ./src/components/packages/PackagesPage.js